const MrtInitialCellMapping = {
	input: {
		totalAmountInclVat: "Initial!B3",
		operationType: "Initial!B4",
		pjSelected: "Initial!B5",
		brokerCommission: "Initial!B8",
		brokerMinCommission: "Initial!B9",
		brokerFees: "Initial!B10",
	},
	output: {
		trcPrimeHT: {
			cellReference: "Initial!G3",
			outputType: "price",
		},
		trcPrimeTaxes: {
			cellReference: "Initial!H3",
			outputType: "price",
		},
		trcPrimeTTC: {
			cellReference: "Initial!I3",
			outputType: "price",
		},
		trcPrimeRateHT: {
			cellReference: "Initial!J3",
			outputType: "percentage",
		},
		trcNaturalDisastersPrimeHT: {
			cellReference: "Initial!G4",
			outputType: "price",
		},
		trcNaturalDisastersPrimeTaxes: {
			cellReference: "Initial!H4",
			outputType: "price",
		},
		trcNaturalDisastersPrimeTTC: {
			cellReference: "Initial!I4",
			outputType: "price",
		},
		trcTerrorismContributionPrimeHT: {
			cellReference: "Initial!G5",
			outputType: "price",
		},
		trcTerrorismContributionPrimeTaxes: {
			cellReference: "Initial!H5",
			outputType: "price",
		},
		trcTerrorismContributionPrimeTTC: {
			cellReference: "Initial!I5",
			outputType: "price",
		},
		rcmoPrimeHT: {
			cellReference: "Initial!G6",
			outputType: "price",
		},
		rcmoPrimeTaxes: {
			cellReference: "Initial!H6",
			outputType: "price",
		},
		rcmoPrimeTTC: {
			cellReference: "Initial!I6",
			outputType: "price",
		},
		rcmoPrimeRateHT: {
			cellReference: "Initial!J6",
			outputType: "percentage",
		},
		doCnrPrimeHT: { cellReference: "Initial!G7", outputType: "price" },
		doCnrPrimeTaxes: { cellReference: "Initial!H7", outputType: "price" },
		doCnrPrimeTTC: { cellReference: "Initial!I7", outputType: "price" },
		doCnrPrimeRateHT: {
			cellReference: "Initial!J7",
			outputType: "percentage",
		},
		pjPrimeHT: { cellReference: "Initial!G8", outputType: "price" },
		pjPrimeTaxes: { cellReference: "Initial!H8", outputType: "price" },
		pjPrimeTTC: { cellReference: "Initial!I8", outputType: "price" },
		duneManagementFeesHT: { cellReference: "Initial!G9", outputType: "price" },
		duneManagementFeesTaxes: {
			cellReference: "Initial!H9",
			outputType: "price",
		},
		duneManagementFeesTTC: { cellReference: "Initial!I9", outputType: "price" },
		intermediaryManagementFeesHT: {
			cellReference: "Initial!G10",
			outputType: "price",
		},
		intermediaryManagementFeesTaxes: {
			cellReference: "Initial!H10",
			outputType: "price",
		},
		intermediaryManagementFeesTTC: {
			cellReference: "Initial!I10",
			outputType: "price",
		},
		totalClientPrimeHT: { cellReference: "Initial!G11", outputType: "price" },
		totalClientPrimeTaxes: {
			cellReference: "Initial!H11",
			outputType: "price",
		},
		totalClientPrimeTTC: { cellReference: "Initial!I11", outputType: "price" },
		totalClientPrimeRateHT: {
			cellReference: "Initial!J11",
			outputType: "percentage",
		},

		agreedRateHT: { cellReference: "Initial!G13", outputType: "percentage" },
		agreedRateTTC: { cellReference: "Initial!G14", outputType: "percentage" },

		brokerCommission: { cellReference: "Initial!G16", outputType: "price" },
		brokerRemuneration: { cellReference: "Initial!G17", outputType: "price" },
		totalClientPrimeWithoutBrokerRemuneration: {
			cellReference: "Initial!G18",
			outputType: "price",
		},

		duneNetCommission: { cellReference: "Initial!G20", outputType: "price" },
		duneNetRemuneration: { cellReference: "Initial!G21", outputType: "price" },
	},
};

export { MrtInitialCellMapping };
